export default "assets/images/nose-b74fb049.svg";